<!-- <div class="grid grid-cols-12 gap-4 md:gap-6"> -->
<!-- <div class="col-span-12 space-y-6 xl:col-span-7">
    <div><app-ecommerce-metrics /></div>

    <div><app-monthly-sales-chart /></div>
  </div> -->

<!-- <div class="col-span-12 xl:col-span-5">
    <app-monthly-target />
  </div> -->
<!-- 
  <div class="col-span-12">
    <app-statics-chart />
  </div> -->

<!-- <div class="col-span-12 xl:col-span-5">
    <app-demographic-card />
  </div> -->
<!-- 
  <div class="col-span-12 xl:col-span-7">
    <app-recent-orders />
  </div> -->
<!-- </div> -->
<div class="min-h-screen relative overflow-hidden">
  <div class="relative z-10 p-6">
    <!-- WELCOME -->
    <div class="mb-6">
      <div class="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-2">
        <div>
          <h1 class="text-3xl xl:text-4xl font-bold text-slate-800 dark:text-white tracking-tight">
            Welcome back,
            <span class="bg-gradient-to-r from-indigo-600 to-blue-500 dark:from-indigo-400 dark:to-cyan-400 bg-clip-text text-transparent">
              {{ userName }}
            </span>
          </h1>
          <p class="mt-2 text-sm sm:text-base text-slate-500 dark:text-slate-400">
            Here's an overview of your EDI transactions.
          </p>
        </div>
        <div class="text-sm font-medium text-slate-400 dark:text-slate-500">
          {{ today | date: 'EEEE, MMMM d' }}
        </div>
      </div>
    </div>
      <!-- KPI SECTION -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mt-6">
        @for (item of stats; track item.title) {
          <div
            class="group relative bg-white dark:bg-slate-900 rounded-2xl p-5 border border-slate-200 dark:border-slate-800 shadow-sm hover:-translate-y-1 hover:shadow-xl transition-all duration-300 overflow-hidden"
          >
              <!-- Subtle Gradient Hover Effect -->
              <div
                class="absolute inset-0 opacity-0 group-hover:opacity-[0.05] transition-opacity duration-300 pointer-events-none"
                [ngClass]="{
                  'bg-gradient-to-br from-blue-500 to-blue-600':
                    item.theme === 'blue',
                  'bg-gradient-to-br from-green-500 to-green-600':
                    item.theme === 'green',
                  'bg-gradient-to-br from-amber-500 to-amber-600':
                    item.theme === 'amber',
                  'bg-gradient-to-br from-red-500 to-red-600':
                    item.theme === 'red',
                }"
              ></div>

              <div class="relative z-10">
                <!-- Icon Badge + Title Row -->
                <div class="flex items-center gap-3 mb-3">
                  <!-- Themed Icon Badge -->
                  <div
                    class="w-12 h-12 rounded-xl flex items-center justify-center shrink-0 transition-transform group-hover:scale-105"
                    [ngClass]="{
                      'bg-blue-100 text-blue-600 dark:bg-blue-500/20 dark:text-blue-400':
                        item.theme === 'blue',
                      'bg-green-100 text-green-600 dark:bg-green-500/20 dark:text-green-400':
                        item.theme === 'green',
                      'bg-amber-100 text-amber-600 dark:bg-amber-500/20 dark:text-amber-400':
                        item.theme === 'amber',
                      'bg-red-100 text-red-600 dark:bg-red-500/20 dark:text-red-400':
                        item.theme === 'red',
                    }"
                  >
                    <i
                      class="pi text-2xl"
                      [ngClass]="item.icon"
                      style="font-size: 1.3rem"
                    ></i>
                  </div>

                  <!-- Title -->
                  <div
                    class="text-sm font-medium text-slate-600 dark:text-slate-400 flex-1"
                  >
                    {{ item.title }}
                  </div>
                </div>

                <!-- Value -->
                <div
                  class="text-3xl font-bold text-slate-800 dark:text-white tracking-tight mb-1"
                >
                  {{ item.value }}
                </div>

                <!-- Description -->
                <p
                  class="text-[11px] leading-snug text-slate-500 dark:text-slate-400"
                >
                  {{ item.description }}
                </p>
              </div>
            </div>
          }
    </div>

    <!-- CHARTS SECTION -->
    <div class="grid xl:grid-cols-3 gap-6 mt-6">
      <!-- BAR CHART -->

      <div
        class="xl:col-span-2 flex flex-col overflow-hidden rounded-3xl bg-white dark:bg-slate-950 border border-slate-200 dark:border-indigo-500/20 shadow-lg dark:shadow-[0_0_40px_rgba(70,95,255,0.15)] p-6"
      >
        <div class="flex justify-between mb-6">
          <h3 class="text-xl font-semibold text-slate-800 dark:text-white">
            Document Volume Trend
          </h3>
          <span
            class="px-3 py-1 rounded-full text-xs font-medium bg-indigo-100 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-400"
          >
            Last 7 days
          </span>
        </div>

        <div>
          <app-bar-chart-one
            [series]="trendSeries"
            [labels]="trendLabels"
            [colors]="['#465FFF', '#22C55E']"
            [height]="300"
          >
          </app-bar-chart-one>
        </div>
      </div>

      <!-- Documents by Status -->
      <div
        class="flex flex-col overflow-hidden rounded-3xl bg-white dark:bg-slate-950 border border-slate-200 dark:border-indigo-500/20 shadow-lg dark:shadow-[0_0_40px_rgba(70,95,255,0.15)] p-5"
      >
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold dark:text-white">
            Documents by Status
          </h3>
          <span
            class="px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-700 dark:bg-green-500/10 dark:text-green-400"
          >
            {{ statusTotal }} docs
          </span>
        </div>

        <div class="flex-1 min-h-0">
          <app-pie-chart
            [series]="statusSeries"
            [labels]="statusLabels"
            [colors]="statusColors"
            [totalLabel]="'Documents'"
            [totalValue]="statusTotal"
            [height]="330"
          />
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 gap-6 mt-6">
      <!-- Status Trend (full width) -->
      <div
        class="min-h-[420px] flex flex-col overflow-hidden rounded-3xl bg-white dark:bg-slate-950 border border-slate-200 dark:border-indigo-500/20 shadow-lg hover:shadow-2xl dark:shadow-[0_0_35px_rgba(70,95,255,0.12)] dark:hover:shadow-[0_0_50px_rgba(70,95,255,0.25)] transition-all duration-300 p-5 sm:p-6"
      >
        <div class="flex items-center justify-between mb-5">
          <div>
            <h3 class="text-lg font-bold text-slate-800 dark:text-white">
              Status Trend
            </h3>

            <p class="text-sm text-slate-500 dark:text-slate-400">
              How each status evolved over time
            </p>
          </div>

          <div
            class="px-3 py-1 rounded-full text-xs font-medium bg-indigo-100 text-indigo-700 dark:bg-indigo-500/10 dark:text-indigo-400"
          >
            Last 7 days
          </div>
        </div>

        <div class="mt-2 flex-1 min-h-0">
          @if (statusTrendLabels.length > 0) {
            <app-bar-chart-one
              [series]="statusTrendSeries"
              [labels]="statusTrendLabels"
              [colors]="statusTrendColors"
              [stacked]="true"
              [height]="300"
            />
          } @else {
            <p class="text-sm text-slate-500 dark:text-slate-400 text-center py-10">
              No data yet
            </p>
          }
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6">
      <!-- File Format Distribution -->
      <div
        class="min-h-[380px] flex flex-col overflow-hidden rounded-3xl bg-white dark:bg-slate-950 border border-slate-200 dark:border-indigo-500/20 shadow-lg hover:shadow-2xl dark:shadow-[0_0_35px_rgba(70,95,255,0.12)] dark:hover:shadow-[0_0_50px_rgba(70,95,255,0.25)] transition-all duration-300 p-5 sm:p-6"
      >
        <div class="flex items-center justify-between mb-5">
          <div>
            <h3 class="text-lg font-bold text-slate-800 dark:text-white">
              File Format Distribution
            </h3>

            <p class="text-sm text-slate-500 dark:text-slate-400">
              Documents per file format
            </p>
          </div>

          <div
            class="px-3 py-1 rounded-full text-xs font-medium bg-purple-100 text-purple-700 dark:bg-purple-500/10 dark:text-purple-400"
          >
            {{ getTotalOf(fileSeries) }} files
          </div>
        </div>

        <div class="mt-5 flex-1 min-h-0 flex items-center justify-center">
          @if (fileLabels.length > 0) {
            <app-pie-chart
              [series]="fileSeries"
              [labels]="fileLabels"
              [colors]="fileColors"
              [totalLabel]="'Formats'"
              [totalValue]="getTotalOf(fileSeries)"
              [height]="300"
            />
          } @else {
            <p class="text-sm text-slate-500 dark:text-slate-400 text-center py-10">
              No data yet
            </p>
          }
        </div>
      </div>

      <div
        class="min-h-[380px] flex flex-col overflow-hidden rounded-3xl bg-white dark:bg-slate-950 border border-slate-200 dark:border-indigo-500/20 shadow-lg hover:shadow-2xl dark:shadow-[0_0_35px_rgba(70,95,255,0.12)] dark:hover:shadow-[0_0_50px_rgba(70,95,255,0.25)] transition-all duration-300 p-5 sm:p-6"
      >
        <div class="flex items-center justify-between mb-5">
          <div class="flex items-center justify-between">
            <div>
              <h3 class="text-lg font-bold text-slate-800 dark:text-white">
                Top Trading Partners
              </h3>

              <p class="text-sm text-slate-500 dark:text-slate-400">
                By document volume
              </p>
            </div>
          </div>

          <div
            class="px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-700 dark:bg-blue-500/10 dark:text-blue-400"
          >
            Top 8
          </div>
        </div>
        <div class="grid gap-4 mt-2 flex-1 min-h-0 overflow-y-auto pr-1">
          @for (partner of topPartners; track partner.name; let i = $index) {
            <div class="flex items-center gap-3">
              <div
                class="w-9 h-9 rounded-xl flex items-center justify-center text-xs font-bold text-white shrink-0"
                [ngClass]="{
                  'bg-blue-500': i === 0,
                  'bg-indigo-500': i === 1,
                  'bg-violet-500': i === 2,
                  'bg-slate-400 dark:bg-slate-600': i > 2
                }"
              >
                {{ i + 1 }}
              </div>

              <div class="flex-1 min-w-0">
                <div class="flex items-center justify-between mb-1">
                  <span
                    class="text-sm font-medium text-slate-700 dark:text-slate-200 truncate"
                  >
                    {{ partner.name }}
                  </span>

                  <span
                    class="text-sm font-semibold text-slate-800 dark:text-white"
                  >
                    {{ partner.count | number }}
                  </span>
                </div>

                <div
                  class="h-2 rounded-full bg-slate-100 dark:bg-slate-800 overflow-hidden"
                >
                  <div
                    class="h-full rounded-full bg-gradient-to-r from-blue-500 to-indigo-600"
                    [style.width.%]="(partner.count / maxPartnerCount) * 100"
                  ></div>
                </div>
              </div>
            </div>
          } @empty {
            <p class="text-sm text-slate-500 dark:text-slate-400 text-center py-6">
              No partner activity yet
            </p>
          }
        </div>
      </div>

      <!-- Documents by Message Type -->
      <div
        class="min-h-[380px] flex flex-col overflow-hidden rounded-3xl bg-white dark:bg-slate-950 border border-slate-200 dark:border-indigo-500/20 shadow-lg hover:shadow-2xl dark:shadow-[0_0_35px_rgba(70,95,255,0.12)] dark:hover:shadow-[0_0_50px_rgba(70,95,255,0.25)] transition-all duration-300 p-5 sm:p-6"
      >
        <div class="flex items-center justify-between mb-5">
          <div>
            <h3 class="text-lg font-bold text-slate-800 dark:text-white">
              Documents by Message Type
            </h3>

            <p class="text-sm text-slate-500 dark:text-slate-400">
              EDI document types processed
            </p>
          </div>

          <div
            class="px-3 py-1 rounded-full text-xs font-medium bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-400"
          >
            Live
          </div>
        </div>

        <div class="mt-5 flex-1 min-h-0 flex items-center justify-center">
          @if (messageLabels.length > 0) {
            <app-pie-chart
              [series]="messageSeries"
              [labels]="messageLabels"
              [colors]="messageColors"
              [totalLabel]="'Documents'"
              [totalValue]="getTotalOf(messageSeries)"
              [height]="300"
            />
          } @else {
            <p class="text-sm text-slate-500 dark:text-slate-400 text-center py-10">
              No data yet
            </p>
          }
        </div>
      </div>
    </div>

    <div class="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-6">
      <!-- Volume by Protocol -->
      <div
        class="min-h-[380px] flex flex-col overflow-hidden rounded-3xl bg-white dark:bg-slate-950 border border-slate-200 dark:border-indigo-500/20 shadow-lg hover:shadow-2xl dark:shadow-[0_0_35px_rgba(70,95,255,0.12)] dark:hover:shadow-[0_0_50px_rgba(70,95,255,0.25)] transition-all duration-300 p-5 sm:p-6"
      >
        <div class="flex items-center justify-between mb-4">
          <div>
            <h3 class="text-lg font-bold text-slate-800 dark:text-white">
              Volume by Protocol
            </h3>

            <p class="text-sm text-slate-500 dark:text-slate-400">
              Documents per connectivity channel
            </p>
          </div>

          <div
            class="px-3 py-1 rounded-full text-xs font-medium bg-violet-100 text-violet-700 dark:bg-violet-500/10 dark:text-violet-400"
          >
            All protocols
          </div>
        </div>

        <div class="mt-4 flex-1 min-h-0">
          @if (protocolLabels.length > 0) {
            <app-bar-chart-one
              [series]="protocolSeries"
              [labels]="protocolLabels"
              [colors]="protocolColors"
              [height]="280"
              [columnWidth]="'22%'"
              [minWidth]="300"
              [distributed]="true"
            />
          } @else {
            <p class="text-sm text-slate-500 dark:text-slate-400 text-center py-10">
              No data yet
            </p>
          }
        </div>
      </div>

      <!-- ACK Status -->
      <div
        class="min-h-[380px] flex flex-col overflow-hidden rounded-3xl bg-white dark:bg-slate-950 border border-slate-200 dark:border-indigo-500/20 shadow-lg hover:shadow-2xl dark:shadow-[0_0_35px_rgba(70,95,255,0.12)] dark:hover:shadow-[0_0_50px_rgba(70,95,255,0.25)] transition-all duration-300 p-5 sm:p-6"
      >
        <div class="flex items-center justify-between mb-4">
          <div>
            <h3 class="text-lg font-bold text-slate-800 dark:text-white">
              Acknowledgement Status
            </h3>

            <p class="text-sm text-slate-500 dark:text-slate-400">
              ACK received vs pending vs failed
            </p>
          </div>

          <div
            class="px-3 py-1 rounded-full text-xs font-medium bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-400"
          >
            ACK
          </div>
        </div>

        <div class="mt-6 flex-1 min-h-0 flex items-center justify-center">
          @if (ackLabels.length > 0) {
            <app-pie-chart
              [series]="ackSeries"
              [labels]="ackLabels"
              [colors]="ackColors"
              [totalLabel]="'ACKs'"
              [totalValue]="getTotalOf(ackSeries)"
              [height]="260"
            />
          } @else {
            <p class="text-sm text-slate-500 dark:text-slate-400 text-center py-10">
              No data yet
            </p>
          }
        </div>
      </div>

      <!-- Recent Processing Activity -->
      <div
        class="h-[430px] flex flex-col overflow-hidden rounded-3xl bg-white dark:bg-slate-950 border border-slate-200 dark:border-indigo-500/20 shadow-lg hover:shadow-2xl dark:shadow-[0_0_35px_rgba(70,95,255,0.12)] dark:hover:shadow-[0_0_50px_rgba(70,95,255,0.25)] transition-all duration-300 p-5 sm:p-6"
      >
        <div class="flex items-center justify-between mb-4">
          <div>
            <h3 class="text-lg font-bold text-slate-800 dark:text-white">
              Recent Processing Activity
            </h3>

            <p class="text-sm text-slate-500 dark:text-slate-400">
              Latest document processing events
            </p>
          </div>
        </div>

        <div class="divide-y divide-slate-100 dark:divide-slate-800 flex-1 min-h-0 overflow-y-auto pr-1">
          @for (event of recentActivity; track $index) {
            <div class="py-3 flex items-start gap-3">
              <div
                class="mt-1 w-2 h-2 rounded-full shrink-0"
                [ngClass]="{
                  'bg-green-500': (event.status || '').toLowerCase().includes('success'),
                  'bg-red-500': (event.status || '').toLowerCase().includes('error') || (event.status || '').toLowerCase().includes('fail'),
                  'bg-amber-400': !(event.status || '').toLowerCase().includes('success') && !(event.status || '').toLowerCase().includes('error') && !(event.status || '').toLowerCase().includes('fail')
                }"
              ></div>

              <div class="flex-1 min-w-0">
                <div class="flex items-center justify-between gap-2">
                  <span class="text-sm font-semibold text-slate-800 dark:text-white truncate">
                    DOC #{{ event.document_id }}
                  </span>

                  <span class="text-xs text-slate-400 shrink-0">
                    {{ event.created_on | appDate:'MMM d, HH:mm' }}
                  </span>
                </div>

                <div class="text-xs text-slate-500 dark:text-slate-400 truncate">
                  {{ event.remark || (event.code || '—') }}
                </div>
              </div>
            </div>
          } @empty {
            <p class="text-sm text-slate-500 dark:text-slate-400 text-center py-10">
              No recent activity
            </p>
          }
        </div>
      </div>
    </div>

    @if (loading) {
      <div
        class="dash-loader-fade fixed inset-0 z-50 flex items-center justify-center bg-white/60 dark:bg-slate-950/60 backdrop-blur-sm"
      >
        <div class="dash-loader-fade flex flex-col items-center gap-4">
          <div class="relative">
            <div class="dash-loader-glow"></div>
            <div class="dash-loader-ring"></div>
          </div>
          <span class="dash-loader-text text-sm font-semibold tracking-wide">
            Loading Dashboard…
          </span>
          <div class="dash-loader-bar"></div>
        </div>
      </div>
    }
  </div>
</div>
